import { render } from "./SalesDetailsReport.vue?vue&type=template&id=6356c8ac&scoped=true"
import script from "./SalesDetailsReport.vue?vue&type=script&lang=js"
export * from "./SalesDetailsReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=6356c8ac&scoped=true&lang=css&external"
import "./SalesDetailsReport.vue?vue&type=style&index=1&id=6356c8ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6356c8ac"]])

export default __exports__